import React from "react";
import PageHeader from "../components/PageHeader";
import CrudTable from "../components/CrudTable";

export default function FazlaUretim() {
  const columns = [
    { key: "yapildigi_tarih", label: "Yapıldığı Tarih", render: (r) => <span className="text-indigo-700 font-semibold">{r.yapildigi_tarih || "—"}</span> },
    { key: "urun_kodu", label: "Ürün Kodu", mono: true },
    { key: "kalip_kodu", label: "Kalıp Kodu", mono: true },
    { key: "renk", label: "Renk" },
    { key: "aciklama", label: "Açıklama" },
    { key: "siparis_adeti", label: "Toplam Sipariş", num: true },
    { key: "gun_kalite", label: "O Gün 1.Kalite", num: true, render: (r) => <span className="text-sky-700 font-semibold">{(Number(r.gun_kalite) || 0).toLocaleString("tr-TR")}</span> },
    {
      key: "fazla", label: "Bu Tarihteki Fazla", num: true,
      value: (r) => r.fazla ?? 0,
      render: (r) => <span className="text-red-600 font-bold">{(Number(r.fazla) || 0).toLocaleString("tr-TR")}</span>,
    },
  ];
  return (
    <>
      <PageHeader title="Siparişten Fazla Yapılan Ürünler" subtitle="Her ürün için üretim tarih sırasına dizilir; sipariş adedini aşan kısım hangi tarihte ne kadar fazla yapıldıysa o tarih için ayrı satırda gösterilir" />
      <CrudTable
        endpoint="/reports/fazla-uretim"
        listEndpoint="/reports/fazla-uretim"
        columns={columns}
        readOnly
        selectable
        dateField="tarih"
        printTitle="Siparişten Fazla Yapılan Ürünler"
        exportName="Siparişten Fazla Yapılan Ürünler"
      />
    </>
  );
}
